import { ActionTree } from 'vuex';
import { PipelineState } from './state';
import RootState from '@/store/root_state';
import pipeline from '@/pipeline';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import { MicroserviceEnum, mutation, query } from '@/helpers/westeros';
import {
  getAdmissionPipelineRun,
  GetAdmissionPipelineRunQueryResult,
} from '@/store/graphql/queries/westerosQueries';
import {
  upsertAdmissionPipelineRun,
  UpsertAdmissionPipelineRunMutationResult,
} from '@/store/graphql/mutations/westerosMutations';
import { Context } from '@/pipeline/stateMachine';
import { State } from 'xstate';
import Vue from 'vue';
import { AnalyticsActions } from '../analytics/actions';

const actions: ActionTree<PipelineState, RootState> = {
  async START_PIPELINE({ commit, state, rootState, dispatch }): Promise<void> {
    pipeline.start(router, state.currentState);

    pipeline.addTransitionListener(async (currentState: State<Context>) => {
      dispatch(AnalyticsActions.SCREEN_VIEWED);

      try {
        const variables = { admissionId: rootState.admission.admissionId, state: currentState };
        const { data } = await mutation<UpsertAdmissionPipelineRunMutationResult>(
          MicroserviceEnum.ADMISSIONS,
          upsertAdmissionPipelineRun,
          variables,
        ).catch(() => ({ data: null }));

        if (data?.upsertAdmissionPipelineRun) {
          const pipeline: PipelineState = {
            id: data?.upsertAdmissionPipelineRun.id,
            currentState: data?.upsertAdmissionPipelineRun.state,
          };

          commit('SET_PIPELINE', pipeline);
        }
      } catch {
        // suppress error
      }
    }, true);
  },

  async PULL_PIPELINE({ commit, rootState }): Promise<void> {
    const isAuthenticated = Boolean(Vue.$cookies.get('admissions-auth-token'));

    if (!isAuthenticated) return;

    const variables = { admissionId: rootState.admission.admissionId };

    const { data } = await query<GetAdmissionPipelineRunQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      getAdmissionPipelineRun,
      variables,
    ).catch(() => ({ data: null }));

    if (data?.getAdmissionPipelineRun) {
      const pipeline: PipelineState = {
        id: data?.getAdmissionPipelineRun.id,
        currentState: data?.getAdmissionPipelineRun.state,
      };

      commit('SET_PIPELINE', pipeline);
    }
  },
};

export default actions;
